var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.classes,style:(_vm.styles)},[_vm._t("default",[_vm._v("menu body")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }